export const FEATURE_NAMESPACE = 'feature.downtime-dashboard'
